export default "__VITE_ASSET__BnUAe$oB__"